var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowmoveup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84942 10.7004C3.84942 10.886 3.92317 11.0641 4.05445 11.1954C4.18573 11.3266 4.36377 11.4004 4.54942 11.4004C4.73508 11.4004 4.91312 11.3266 5.0444 11.1954C5.17567 11.0641 5.24942 10.886 5.24942 10.7004L5.24943 2.28239L7.92833 4.71839C7.99635 4.78026 8.07589 4.82812 8.16242 4.85924C8.24894 4.89037 8.34074 4.90414 8.43259 4.89979C8.52443 4.89543 8.61452 4.87303 8.69771 4.83386C8.7809 4.79469 8.85556 4.73951 8.91742 4.67149C8.97929 4.60347 9.02715 4.52392 9.05828 4.4374C9.0894 4.35088 9.10318 4.25907 9.09882 4.16723C9.09447 4.07538 9.07207 3.98529 9.03289 3.9021C8.99372 3.81891 8.93855 3.74426 8.87052 3.68239L5.02053 0.18239C4.89165 0.0651241 4.72367 0.000138854 4.54943 0.000138839C4.37518 0.000138823 4.2072 0.0651241 4.07832 0.18239L0.228325 3.68239C0.0909421 3.80733 0.00882118 3.98173 2.54279e-05 4.16723C-0.00877033 4.35272 0.056481 4.53411 0.181425 4.67149C0.306368 4.80887 0.480769 4.89099 0.666261 4.89979C0.851754 4.90858 1.03314 4.84333 1.17053 4.71839L3.84942 2.28239L3.84942 10.7004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowmoveup);
export default __webpack_public_path__ + "static/media/arrowmoveup.eb427e7ff6d654d69ef641f0a04c50f6.svg";
export { ForwardRef as ReactComponent };